import { InvestmentAllocation } from '../../models/InvestmentEntity';

/** Resolve fund opportunity ID from allocation payload shape variants. */
export const getOpportunityId = (allocation: InvestmentAllocation): string | null => {
  if (allocation.fundOpportunity?.id) {
    return allocation.fundOpportunity.id;
  }

  const altFields = ['opportunityId', 'fundOpportunityId'];
  for (const field of altFields) {
    if (field in allocation && (allocation as unknown as Record<string, unknown>)[field]) {
      return String((allocation as unknown as Record<string, unknown>)[field]);
    }
  }

  if (allocation.fundOpportunity) {
    const opp = allocation.fundOpportunity as unknown as Record<string, unknown>;
    const oppAltFields = ['opportunityId', 'fundOpportunityId', 'id'];
    for (const field of oppAltFields) {
      if (opp[field]) {
        return String(opp[field]);
      }
    }
  }

  return null;
};

const ENTITY_TYPE_LABELS: Record<string, string> = {
  INDIVIDUAL: 'Individual',
  TRUST: 'Trust',
  COMPANY: 'Company',
  PARTNERSHIP: 'Partnership',
  SMSF: 'SMSF',
  OTHER: 'Other',
};

const ENTITY_TYPE_COLORS: Record<string, string> = {
  INDIVIDUAL: '#2196F3',
  TRUST: '#4CAF50',
  COMPANY: '#FF9800',
  PARTNERSHIP: '#9C27B0',
  SMSF: '#F44336',
  OTHER: '#607D8B',
};

export const getEntityTypeLabel = (type: string): string => ENTITY_TYPE_LABELS[type] || type;

export const getEntityTypeColor = (type: string): string => ENTITY_TYPE_COLORS[type] || '#607D8B';
